/* eslint-disable consistent-return */
/* eslint-disable no-shadow */
import eve from '@src/commonEvent';
import api from '@api/index';
import EventBus from '@utils/bus';

const state = {
  selected_tab: {}, // 선택된 재생목록에 대한 정보
  userPlaylists: {}, // 회원 재생목록
  playlist_contents: {}, // 일반 재생목록 컨텐츠
  hq_playlist_contents: {}, // 본사(프랜차이즈) 재생목록 컨텐츠
  is_alert_duplicated: true, // 컨텐츠 삭제 시 알림 중복 방지
};

const getters = {
  selectedTab(state) {
    return state.selected_tab;
  },
  getUserPlaylists(state) {
    return state.userPlaylists;
  },
};

const mutations = {
  SET_SELECTED_TAB(state, payload) {
    state.selected_tab = payload;
  },
  SET_USER_PLAYLISTS(state, payload) {
    state.userPlaylists = payload;
  },
  SET_ALERT_STATUS(state, value) {
    state.is_alert_duplicated = value;
  },
};

const actions = {
  SAVE_SELECTED_TAB({ commit }, tabInfo) {
    // 선택된 재생목록에 대한 정보를 저장
    commit('SET_SELECTED_TAB', tabInfo);
  },

  async FETCH_PLAYLIST_FRANCHISE() {
    // 본사 재생목록 컨텐츠 조회
    const response = await api.playList.fetchedHQPlayListContents();
    return response.data.items;
  },

  async FETCH_USER_PLAYLISTS({ commit }) {
    // 회원 재생목록 조회
    const response = await api.playList.getUserPlaylists();
    commit('SET_USER_PLAYLISTS', response.data.items);
    return response;
  },

  async FETCH_PLAYLIST_CONTENTS(_, playlistId) {
    // 재생목록 컨텐츠 조회
    const response = await api.playList.fetchedPlayListContents(playlistId);
    return response.data.items;
  },

  async MODIFY_PLAY_LIST_CONTENT({ commit }, reqInfo) {
    // 재생목록 컨텐츠 수정
    const response = await api.playList.updatePlayListContent(reqInfo);
    // 알림이 중복으로 뜨지 않도록 설정
    if (state.is_alert_duplicated) {
      // 첫번째 알림인 경우
      commit('SET_ALERT_STATUS', false);
      setTimeout(() => {
        commit('SET_ALERT_STATUS', true);
      }, 2000);
      alert(eve.Lang.t('common.t_msg_complete_change'));
    }
    // 알림이 중복되는 경우
    EventBus.$emit('is-opend');
    return response;
  },

  CHANGE_VIDEO_TITLE(_, reqInfo) {
    // 재생목록 컨텐츠명 수정
    return api.playList.editPLayListContentName(reqInfo);
  },

  CONTENT_THUMBNAIL(_, contentId) {
    // 재생목록 컨텐츠 썸네일 조회
    return api.playList.contentsThumbnail(contentId);
  },

  CONTENT_PREVIEW(_, contentId) {
    // 재생목록 컨텐츠 썸네일 클릭 시 보여지는 미리보기 영상 조회
    return api.playList.contentsPreview(contentId);
  },

  async WEATHER_THEME_LIST(_, countryCode) {
    // 날씨 테마 리스트 조회
    const response = await api.playList.weatherTheme(countryCode);
    return response.data.items;
  },

  WEATHER_THUMBNAIL(_, obj) {
    // 날씨 썸네일 조회
    return api.playList.weatherThumbnail(obj);
  },

  async FINEDUST_THEME_LIST() {
    // 미세먼지 테마 리스트 조회
    const response = await api.playList.finedustTheme();
    return response.data.items;
  },

  FINEDUST_THUMBNAIL(_, id) {
    // 미세먼지 썸네일 조회
    return api.playList.finedustThumbnail(id);
  },

  async ULTRAFINEDUST_THEME_LIST() {
    // 초미세먼지 테마 리스트 조회
    const response = await api.playList.ultrafinedustTheme();
    return response.data.items;
  },

  ULTRAFINEDUST_THUMBNAIL(_, id) {
    // 초미세먼지 썸네일 조회
    return api.playList.ultrafinedustThumbnail(id);
  },

  async NEWS_THEME_LIST(_, countryCode) {
    // 뉴스 테마 리스트 조회
    const response = await api.playList.newsTheme(countryCode);
    return response.data.items;
  },

  NEWS_THUMBNAIL(_, obj) {
    // 뉴스 썸네일 조회
    return api.playList.newsThumbnail(obj);
  },

  async CLOCKS_THEME_LIST(_, countryCode) {
    // 시계 테마 리스트 조회
    const response = await api.playList.clocksTheme(countryCode);
    return response.data.items;
  },

  CLOCKS_THUMBNAIL(_, id) {
    // 시계 썸네일 조회
    return api.playList.clocksThumbnail(id);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
